<template>
  <div class="checkbox">
    <label>
      <input
        type="checkbox"
        class="checkbox-input"
        :disabled="disabled"
        :checked="checked"
        @change="change($event)">
      <span class="checkbox-style"></span>
    </label>
  </div>
</template>

<script>
export default {
  name: 'checkbox',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    checked: {
      type: Boolean,
      default: false
    },
    gid: {
      type: [Number, String]
      // required: true
    },
    platform: {
      type: String
    }
  },
  methods: {
    change (e) {
      this.$emit('change', { skuid: this.gid, checkStatus: e.target.checked, platform: this.platform })
    }
  }
}
</script>

<style lang="less" scoped>
.checkbox {
  .checkbox-input {
    display: none;
  }
  label {
    min-width: 0.4rem;
    min-height: 0.4rem;
    .flex-center;
  }
  .checkbox-style {
    display: inline-block;
    min-width: 0.4rem;
    min-height: 0.4rem;
    // border-radius: 50%;
    background: url('../assets/img/unchecked.svg') center no-repeat;
    background-size: 0.36rem;
  }
  .checkbox-input:checked + span {
    background: url('../assets/img/checked.svg') center no-repeat;
    background-size: 0.36rem;
  }
}
</style>
